module.exports = __webpack_public_path__ + "img/img3.b55bf4eb.jpg";